import React from "react";
import AIIcon from "../../images/svgs/AIIcon";
import TransparentButton from "../transparentButton/TransparentButton";

const GraphCard = ({
  title,
  children,
  description,
  buttonText,
  border,
  onClick,
  score,
}) => {
  const getRiskCategory = (score) => {
    if (score < 30) {
      return {
        title: "Low Risk (<30%) → AI as an Enhancer",
        description:
          "Great news! AI is enhancing, not replacing, roles like yours. Leverage AI to work smarter!",
      };
    } else if (score < 60) {
      return {
        // title: "Moderate Risk (30-60%) → AI Adaptability Needed",
        // description:
        //   "Some parts of your role may be automated. Stay ahead with AI-driven skills!",
      };
    } else if (score < 80) {
      return {
        title: "High Risk (61-80%) → Upskilling & Career Pivot",
        description:
          "AI is reshaping your industry, and upskilling can help you adapt. Explore resilient career paths or skill-building resources!",
      };
    } else {
      return {
        title: "Critical Risk (81-100%) → Career Shift & Reskilling",
        description:
          "Your role is at high risk of automation, AI-proof your career!",
      };
    }
  };

  const riskInfo = getRiskCategory(score);
  return (
    <div className="relative p-[1px] rounded-md" style={{ background: border }}>
      {/* Inner Content */}
      <div className="relative py-5 px-4 w-full bg-white rounded-lg shadow-md h-full min-h-[400px] flex flex-col">
        <div className="flex gap-2 items-center">
          <AIIcon />
          <span className="font-medium text-xl text-custom-blue">{title}</span>
        </div>

        <div className="flex flex-col flex-grow">
          <div className="flex-grow flex items-center justify-center py-6">
            {children}
          </div>

          {score && (
            <div className="text-center text-base font-medium text-slate-gray mt-4">
              {/* {description} */}
              <h3 className="text-lg font-semibold text-blue-600">
                {riskInfo.title}
              </h3>
              <p className="text-gray-700">{riskInfo.description}</p>
            </div>
          )}

          {buttonText && (
            <div className="flex justify-center mt-6">
              <TransparentButton
                buttonText={buttonText}
                onClick={onClick}
                buttonClass="px-3.5 py-2.5 border border-custom-blue text-custom-blue text-sm font-medium rounded-lg hover:bg-custom-blue hover:text-white transition-colors duration-200"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GraphCard;
